module.exports = __webpack_public_path__ + "static/media/exp.d1ec7ff6.svg";